module.exports = __webpack_public_path__ + "img/Images reseaux sociaux gif 3.b25867da.png";